import { paramCase } from 'change-case';

import Model from '@/models/Model.js';
import { DialogService } from '@/services/DialogService.js';
import loadingService from '@/services/LoadingService.js';
import QueryBuilder from '@/utilities/QueryBuilder.js';
export default class PageFolder extends Model {
    static entity = 'page_folders';

    static includes = ['icon'];

    static queryBuilder(slug = null) {
        const param = slug ? `/${slug}` : '';

        return new QueryBuilder(paramCase(this.entity) + param).include(this.includes);
    }

    static fields() {
        return {
            id: this.attr(null),
            page_folder_id: this.attr(null),
            icon_id: this.attr(null),
            title: this.string(''),
            slug: this.string(''),
            order: this.number(1),
            path: this.string(''),

            ...super.fields(),

            pages: this.hasMany('pages', 'page_folder_id'),
            page_folders: this.hasMany('page_folders', 'page_folder_id'),
            icon: this.belongsTo('icons', 'icon_id'),
        };
    }

    static async fetch() {
        const { response } = await this.api().get(this.queryBuilder().toUrl());

        return response.data;
    }

    static async fetchOne(slug) {
        const endpoint = this.queryBuilder(slug).toUrl();

        const { response } = await this.api().get(endpoint);

        return response.data;
    }

    static async createModel(model) {
        if (!model.order) model.order = 1;

        const { response } = await this.api().post(this.queryBuilder().toUrl(), model);

        return response.data;
    }

    static async updateModel(slug, model) {
        const endpoint = this.queryBuilder(slug).toUrl();

        const { response } = await this.api().put(endpoint, model);

        return response.data;
    }

    static async deleteModel(model) {
        const endpoint = this.queryBuilder(model.slug).toUrl();

        const folder = PageFolder.query().with('page_folders').whereId(model.id).first();

        const { response } = await this.api().delete(endpoint, {
            delete: model.id,
        });

        if (response.status && folder.page_folders) {
            const folderChildIds = folder.page_folders.map(item => item.id);

            folderChildIds.forEach(id => {
                PageFolder.delete(id);
            });
        }

        return response.data;
    }

    static openDeleteModal(pageFolder, router, route) {
        DialogService.confirm({
            title: 'Removing Page Folder',
            message:
                'Are you sure you want to <strong>remove</strong> this page folder, this will delete <strong>all folders or pages inside</strong>?',
            confirmText: 'Delete',
            type: 'is-danger',
            onConfirm: async () => {
                const loader = loadingService.open();
                try {
                    await PageFolder.deleteModel(pageFolder);

                    const routeWithFolderSlug = [
                        'edit-page-nested',
                        'edit-page-create',
                        'page-folder-create',
                        'page-folder-edit',
                    ];

                    const routeWithSlug = ['edit-page-edit'];

                    const folderExists = PageFolder.query().where('slug', route.params.folderSlug).first();

                    const pageExists = folderExists ? folderExists.pages.length : null;

                    if (
                        (routeWithFolderSlug.includes(route.name) && !folderExists) ||
                        (routeWithSlug.includes(route.name) && !pageExists)
                    ) {
                        await router.push({ name: 'edit-pages-index' });
                    }

                    loader.close();
                } catch (_e) {
                    loader.close();
                }
            },
        });
    }
}
